module.exports = __webpack_public_path__ + "static/media/52577813_2452967691445074_4483648924459991040_o.f6601cbd.jpg";